module.exports = __webpack_public_path__ + "static/media/UserEmpty.d2c769aa.png";